import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`

export const Message = styled.p`
  margin-top: ${Typography.Caption};
  color: ${Colors.Neutral90};
  text-align: center;
  ${Typography.Body};
`
